<div class="highest-bid-heading">{{ heading | translate }}</div>
<div [ngStyle]="{'font-size': (priceDto?.net.toString().length >= 9) ? '18px' : '22px' }" class="highest-bid">
  {{ priceDto?.net | price }} {{ priceDto?.currency?.data }}
  <span class="gross-net">{{ 'api.type.pricetype.NET' | translate }}</span>
</div>
